import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Agent, AgentsService, ConfigurationsService, LocalesService, UtilsService } from '../../core';
import { MatTabGroup } from '@angular/material/tabs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-agent-detail',
  templateUrl: './agent-detail.component.html',
  styleUrls: ['./agent-detail.component.scss']
})
export class AgentDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  public agent: Agent;
  public config: any;
  public tabsManager: any | Subscription = new Subscription();
  public agentGroupslistId = 'AGENT_GROUPS_LIST';
  public tooltips: any = null;
  @ViewChild('tabGroup', { static: false }) public tabGroup: MatTabGroup;

  public rolesConfig = {
    csAdmin: { clients: true, groups: true },
    csm: { clients: true, groups: true },
    supportSpecialist: { clients: true, groups: true },
    sales: { clients: true, groups: true },
    distributorManager: { clients: false, groups: false },
    distributor: { clients: false, groups: false },
    clientAdmin: { clients: false, groups: true },
    hr: { clients: false, groups: true }
  };

  constructor(
    public agentsService: AgentsService,
    public route: ActivatedRoute,
    public router: Router,
    public translate: TranslateService,
    private localesService: LocalesService,
    private cd: ChangeDetectorRef,
    private configurationsService: ConfigurationsService
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.agent = data['agent'];
      this.config = this.rolesConfig[this.agent.role] || { clients: false, groups: false };
      this.configurationsService
        .getInfoMessage$(
          'toolTip',
          'fields.keys[match]',
          'agents.edit',
          'textoDeAyuda',
          this.localesService.getBrowserLocale()
        )
        .subscribe((tooltipsMap) => {
          this.tooltips = tooltipsMap;
        });
    });
  }

  public ngAfterViewInit(): void {
    this.tabsManager = UtilsService.createTabsManager(this.route, this.tabGroup);
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.tabsManager.unsubscribe();
  }

  onUpdateAgent(event: CustomEvent): void {
    this.agent = event.detail;
  }

  onDeleted(): void {
    this.router.navigate(['/agents']);
  }

  onRoleChanged(event: CustomEvent): void {
    if (event.detail) {
      this.agent = { ...this.agent, ...event.detail };
    }
  }
}
